RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TrackedPage = Marionette.ItemView.extend({
        template: '#adminCompanyTrackedPageTemplate',
        className: 'col-md-6',

        ui: {
            setPrimaryBtn: '.x-set-primary',
            deleteBtn: '.x-delete',
            pageTypeSel: '.x-sel-page-type'
        },

        events: {
            'click @ui.setPrimaryBtn': 'setAsPrimary',
            'click @ui.deleteBtn': 'delete',
            'change @ui.pageTypeSel': 'changePageType'
        },

        templateHelpers: function () {
            const me = this;
            const model = me.model.toJSON();

            return {
                url: `${model.https ? 'https' : 'http'}://${model.host}/${model.path}`,
                pageTypes: me.model.collection.pageTypes.toJSON()
            };
        },

        setAsPrimary: function () {
            const me = this;
            me.model.set({
                is_primary: true
            });
        },

        delete: function () {
            const me = this;
            me.model.trigger('destroy', me.model, me.model.collection);
        },

        changePageType: function () {
            const me = this;
            const pageTypeId = parseInt(me.ui.pageTypeSel.val());
            me.model.set({
                page_type_id: (_.isFinite(pageTypeId) ? pageTypeId : null)
            });
        }
    });

});
